import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Formula One", href: "#formula-one", testid: "nav-link-f1" },
  { label: "Football", href: "#football", testid: "nav-link-football" },
  { label: "What We Do", href: "#services", testid: "nav-link-services" },
  { label: "Global", href: "#global", testid: "nav-link-global" },
  { label: "About", href: "#about", testid: "nav-link-about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="hover:opacity-80 transition-opacity duration-200"
        >
          <img src="/qualive-logo.png" alt="QUALIVE" className="h-5 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-[#F7F6F2] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="font-mono-tech text-[11px] uppercase tracking-[0.2em] border border-white/25 px-5 py-2.5 text-[#F7F6F2] hover:border-[#F7F6F2] hover:text-[#F7F6F2] transition-colors duration-200"
          >
            Discuss a Partnership
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#F7F6F2] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-[#0A0A0A] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="font-mono-tech text-xs uppercase tracking-[0.2em] text-neutral-300 hover:text-[#F7F6F2] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button-mobile"
            onClick={() => setOpen(false)}
            className="font-mono-tech text-xs uppercase tracking-[0.2em] border border-white/25 px-5 py-3 text-center hover:border-[#F7F6F2] hover:text-[#F7F6F2] transition-colors duration-200"
          >
            Discuss a Partnership
          </a>
        </nav>
      )}
    </header>
  );
}
